/**
 * Checks if the account form feature is enabled
 * @returns true if both VITE_USE_ACCOUNT_FORM and VITE_ACCOUNT_FORM_URL are set
 */
export function useAccountForm(): boolean {
  const useAccountForm = import.meta.env.VITE_USE_ACCOUNT_FORM;
  const accountFormUrl = import.meta.env.VITE_ACCOUNT_FORM_URL;
  return !!(useAccountForm && accountFormUrl);
}

/**
 * Gets the account form URL
 * @returns the account form URL or undefined if not set
 */
export function getAccountFormUrl(): string | undefined {
  return import.meta.env.VITE_ACCOUNT_FORM_URL;
}
